import React from "react";
import PropTypes from "prop-types";
import Text, {
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_ALIGN,
  TEXT_SIZE,
} from "@/bit/components/components.text";
import { createCmsLabelProps } from "./utils";
import { LABEL_SHAPES, LABEL_TYPES, LABEL_STYLES } from "./enums";

/**
 * Elemento de interfaz que muestra texto para describir o identificar otros componentes. No es interactivo, pero proporciona información útil al usuario.
 */
const Label = (props) => {
  const { text, color, opacity, cyData, cms, cmsHandler, className } =
    createCmsLabelProps(props);

  if (!text) {
    return null;
  }

  return (
    <div
      className={className}
      onClick={
        cms && cmsHandler ? () => cmsHandler({ ...props, name: "cms-block.label" }) : null
      }
    >
      <Text
        text={text}
        color={color}
        opacity={opacity}
        kind={TEXT_KIND.SPAN}
        size={TEXT_SIZE.CAPTION}
        fontType={TEXT_FONT_WEIGHT.REGULAR}
        align={TEXT_ALIGN.CENTER}
        cyData={cyData}
        cmsHandler={cmsHandler}
      />

      <style jsx>{`@import "styles/colors.scss";

.cms-label {
  width: fit-content;
  height: 22px;

  &.promocion {
    background-color: $color-gp--red_dark;
  }
  &.promocion-inverse {
    background-color: $color-gp--white;
  }
  &.informacion, &.recomendado {
    background-color: $color-gp--blue_dark;
  }
  &.informacion-inverse {
    background-color: $color-gp--white;
  }
  &.active {
    background-color: $color-gp--blue_o10;
  }
  &.active-inverse {
    background-color: $color-gp--white;
  }
  &.inactive {
    background-color: $color-gp--grey1;
  }
  &.inactive-inverse {
    background-color: $color-gp--white;
  }
  &.success, &.contratado {
    background-color: $color-gp--green_o10;
  }
  &.success-inverse {
    background-color: $color-gp--white;
  }
  &.warning {
    background-color: $color-gp--orange_o10;
  }
  &.warning-inverse {
    background-color: $color-gp--white;
  }
  &.error {
    background-color: $color-gp--red_o10;
  }
  &.error-inverse {
    background-color: $color-gp--white;
  }

  &.square {
    border-radius: 0px;
    padding: 2px 4px;
  }
  &.tears {
    border-radius: 16px 0px;
    padding: 2px 16px;
  }
  &.roof {
    border-radius: 16px 16px 0px 0px;
    padding: 2px 16px;
    width: 100%;
  }
}
`}</style>
    </div>
  );
};

Label.propTypes = {
  /**
   * {
   *  "info": "Define la forma del label y puede ser uno de los siguientes valores: 'square','tears' o 'roof'",
   *  "kind": "both",
   *  "beautifulName": "Shape",
   *  "values": "./enums.js:LABEL_SHAPES"
   * }
   */
  shape: PropTypes.string,

  /**
   * {
   *  "info": "Define el tipo de label y puede ser uno de los siguientes valores: 'promocion', 'informacion', 'active', 'inactive','success', 'warning','error', 'recomendado', 'contratado'",
   *  "kind": "both",
   *  "beautifulName": "Type",
   *  "values": "./enums.js:LABEL_TYPES"
   * }
   */
  type: PropTypes.string,

  /**
   * {
   *  "info": "Texto del label",
   *  "kind": "both",
   *  "beautifulName": "Text"
   * }
   */
  text: PropTypes.string.isRequired,

  /**
   * {
   *  "info": "Datos de prueba para Cypress.",
   *  "kind": "dev",
   *  "beautifulName": "CyData"
   * }
   */
  cyData: PropTypes.string,

  /**
   * {
   *  "info": "Objeto con información sobre las propiedades necesarias (id, timestamp...) para editar los valores en orion.",
   *  "kind": "dev",
   *  "beautifulName": "CMS"
   * }
   */
  cms: PropTypes.object,

  /**
   * {
   *  "info": "Handler para eventos del CMS. Se ejecuta cuando se clicka en el componente desde el CMS.",
   *  "kind": "dev",
   *  "beautifulName": "CMS Handler"
   * }
   */
  cmsHandler: PropTypes.func,
};

Label.defaultProps = {
  shape: LABEL_SHAPES.SQUARE,
  type: LABEL_TYPES.PROMOCION,
  cyData: "",
  cms: null,
  cmsHandler: null,
};

export default Label;
export { LABEL_SHAPES, LABEL_TYPES, LABEL_STYLES };
